<template>
    <div class="form-group" v-bind:class="[{ 'has-messaging': uiStates.message },{'invisible' : field.hide}, 'has-'+uiStates.messageClass+'-message']">
        <div class="input-group">
            <div v-if="typeof field.prepend !== 'undefined' && field.prepend.enabled == true" class="input-group-prepend">
                <span class="input-group-text">
                    <span v-html="field.prepend.value"></span>
                </span>
            </div>
            <input v-model="field.value" :disabled="field.disabled" :readonly="field.readonly ? true : false" type="text" :name="field.name" :required="field.required ? true : false" :maxlength="field.maxlength" class="form-control">
            <div v-if="typeof field.append !== 'undefined' && field.append.enabled == true" class="input-group-append">
                <span class="input-group-text">
                    <span v-html="field.append.value"></span>
                </span>
            </div>
        </div>
        <small v-if="(this.activeLanguage !== 0) && (typeof masterValue !== 'undefined')" class="form-text text-muted">Master Value: {{ masterValue }}</small>
        <ul v-if="uiStates.message" class="message-listing">
            <li>{{uiStates.message}}</li>
        </ul>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'form-input-text',
        props: ['FieldData', 'masterValue', 'activeLanguage', 'index'],
        components:{
        },
        data() {
            return {
                uiStates: {
                    message:"",
                    messageClass:"",
                },
                field: this.FieldData,
            }
        },
        mounted() {
            this.$emit('input', this.field.value);
        },
        created() {

        },
        watch: {

        },
        methods: {

        }
    };
</script>

<style scoped lang="scss">
    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label{
        position: relative;
    }
</style>
